<template>
    <div class="c_table_wrap">
        <table class="memberInfo_table">
            <colgroup>
                <col width="200px;">
                <col width="">
            </colgroup>
            <tr>
                <td class="c_t_title">언어선택</td>
                <td class="write_content_td">
                    <!--          <el-input v-model="language" type="number" @input="parentChange('language',language)"></el-input>-->
                    <el-select v-model="language" @change="parentChange('language',language)"
                               :disabled="checkData(boardData)">
                        <el-option v-for="(data, value, index) in languageList" :key="`faqLanguage${value}`"
                                   :label="data.c_lang_ko" :value="Number(data.c_idx)"></el-option>
                    </el-select>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">카테고리</td>
                <td class="write_content_td">
                    <el-select v-model="value" @change="parentChange('bc_idx', value)">
                        <el-option v-for="category in categoryList" :key="`category${category.bc_idx}`"
                                   :value="category.bc_idx"
                                   :label="category.bc_name"></el-option>
                    </el-select>
                    <div class="input_error mt5">{{ validation.firstError('category') }}</div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">노출순서</td>
                <td class="write_content_td">
                    <div class="write_content_div exposure">
                        <el-input v-model="seq" type="number" @input="parentChange('seq',seq)"></el-input>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">제목</td>
                <td class="write_content_td">
                    <div class="write_content_div">
                        <el-input v-model="title" type="text" @input="parentChange('title', title)"
                                  maxlength="30"></el-input>
                        <div class="input_error mt5">{{ validation.firstError('title') }}</div>
                    </div>
                </td>
            </tr>

            <tr>
                <td class="c_t_title">내용</td>
                <td class="write_content_td">
                    <div class="write_content_div">
                        <quill-editor
                            ref="contentEditor"
                            class="h300"
                            v-model="content"
                            :options="editorOption"
                        />
                        <div class="input_error">{{ validation.firstError('content') }}</div>
                    </div>
                </td>
            </tr>
        </table>

    </div>
</template>

<script>
import alertMixins from "@/mixins/alertMixins";
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import boardValidator from "@/mixins/validators/boardValidator";
import quillEditorMixins from "@/mixins/quillEditorMixins";
import {appLanguage} from "@/service/languageService"

export default {
    name: "BoardWriteFaqLayout",
    mixins: [alertMixins, boardValidator, quillEditorMixins],
    components: {},
    inject: {
        boardWriteSetData: {
            default: () => {
            }
        },
    },
    provide() {
        return {}
    },
    props: {
        boardData: {
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            value: '카테고리 선택',
            seq: 0,
            categoryList: [],
            languageList: appLanguage,
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.getCategory();
    },
    mounted() {
        if (this.hasData()) {
            this.initSetData();
        } else {
            this.wr_seq = this.seq;
            this.boardWriteSetData('wr_seq', this.seq);
            this.boardWriteSetData('seq', this.seq);
        }
        EventBus.$on('BoardWriteFaqLayoutValidator', this.checkValidator);
    },
    beforeDestroy() {
        EventBus.$off('BoardWriteFaqLayoutValidator')
    },
    destroyed() {
    },
    computed: {},
    methods: {
        initSetData() {
            this.value = this.boardData.bc_idx;
            this.parentChange('bc_idx', this.value);
            this.title = this.boardData.wr_subject;
            this.parentChange('title', this.title);
            this.language = this.boardData.Language.c_idx;
            this.parentChange('language', this.language);
            this.seq = this.boardData.wr_seq;
            this.parentChange('seq', this.seq);
            this.content = this.boardData.wr_content;
            this.content = util.htmlDecode(this.content);
            this.parentChange('content', this.content);
        },
        hasData() {
            return !util.isEmpty(this.boardData) && !util.isEmpty(this.boardData.wr_id);
        },
        checkValidator(dataArr) {
            this.$validate(dataArr)
        },
        parentChange(key, value) {
            if (key === 'content') {
                this.content = this.replaceN(value);
                value = this.content
            }
            this.boardWriteSetData(key, value)
        },
        getCategory() {
            let params = {
                ip: 1,
            }
            this.$api.$board.getCategory(params).then(res => res.Data.Result).then(res => {
                if (res.Info.type != 1) {
                    this.createAlert({
                        title: '',
                        content: '데이터를 불러올 수 없습니다.',
                        btnText: '확인',
                        hide: () => {
                            this.$router.back();
                        }
                    });
                    return;
                }
                this.categoryList = res.List;
            })
        },
        checkData(data) {
            return !util.isEmpty(data);
        },
    },
    watch: {
        'content': {
            deep: true,
            handler: function (val, oldVal) {
                this.parentChange('content', this.content)
            },
        }
    },
}
</script>

<style scoped>

</style>
